import React from 'react';
import ValidationMessage from '../validation/validationMessage';
import { useValidationControl, ValidationControlProps } from 'src/shared/validation';
import { styled } from 'styled-components';

interface TextAreaProps extends React.ComponentProps<'textarea'>, ValidationControlProps<string> {
    isError?: boolean;
}

const TextAreaBase = styled.textarea<{ isError?: boolean }>`
    color: ${(props) => props.theme.input.color};
    width: 100%;
    box-sizing: border-box;
    resize: none;
    border: 1px #ddd solid;
    border-radius: 4px;
    padding: 4px 10px;
    font-family: ${(props) => props.theme.app.font};
    font-size: ${(props) => props.theme.input.textSize};

    &::placeholder {
        font-size: 13px;
    }

    &:focus,
    &:active {
        outline: none;
        ${(props) => (props.isError ? 'border-color: #DE1C22;' : `border-color: #ddd`)}
    }

    ${(props) => (props.readOnly ? 'background-color: transparent;' : '')}

    ${(props) => props.isError && 'border-color: #DE1C22;'}
    ${(props) => props.isError && 'color: #DE1C22;'}
    ${(props) => props.isError && 'box-shadow: 0 0 0 2px rgba(222, 28, 34, 0.2);'}
`;

const _TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>((props, ref) => {
    const { validationKey, validate, validationMessage, message, validationLabel, validationValue, isError, value, className, ...textAreaProps } = props;
    const valueToValidate = validationValue?.toString() ?? value?.toString() ?? '';
    const validation = useValidationControl<HTMLTextAreaElement, string>(
        { validationKey, validate, validationMessage: validationMessage ?? message, validationLabel, validationValue: valueToValidate },
        valueToValidate,
        ref
    );

    return (
        <>
            <TextAreaBase {...textAreaProps} ref={validation.setRef} value={value} className={className} isError={isError || validation.isValidationError} />
            {validation.validationKey && <ValidationMessage validationKey={validation.validationKey} deferUntilSubmit />}
        </>
    );
});

export const TextArea = styled(_TextArea)``;
